import { AiSummarySchema } from '@/entities/market-intel/model/contracts';
import z from 'zod';

export const GetAiSummaryRequestDtoSchema = z.object({
  facilityId: z.number(),
});
export const GetAiSummaryResponseDtoSchema = AiSummarySchema;

export type GetAiSummaryRequestDto = z.infer<
  typeof GetAiSummaryRequestDtoSchema
>;
export type GetAiSummaryResponseDto = z.infer<
  typeof GetAiSummaryResponseDtoSchema
>;

export const getAiSummary = async () =>
  // uncomment and use this once endpoints are ready
  // params: GetAiSummaryRequestDto
  // config?: AxiosRequestConfig<GetMarketIntelTableRequestDto>
  {
    await new Promise((resolve) => setTimeout(resolve, 300));

    // return mocked data
    return {
      summary: `The average occupancy over the past 12 months remained stable (≈70%).
        However, in the current period the rate dropped to 72%, which is 8.7%
        below the market. The main reason for the gap is a higher turnover level
        (+7% compared to the market).`,
      recommendation: `focus on extending residents’ length of stay and
        retaining current tenants.`,
    };
  };
